(function () {
  var drawer = document.getElementById('cartDrawer');
  var overlay = document.getElementById('cdOverlay');
  if (!drawer || !overlay) return;

  var itemsEl = document.getElementById('cdItems');
  var emptyEl = document.getElementById('cdEmpty');
  var footEl = document.getElementById('cdFoot');
  var subtotalEl = document.getElementById('cdSubtotal');
  var countEl = document.getElementById('cdCount');
  var closeBtn = document.getElementById('cdClose');
  var rewardsEl = document.getElementById('cdRewards');
  var rewardsMsgEl = document.getElementById('cdRewardsMsg');
  var trackFillEl = document.getElementById('cdTrackFill');
  var upsellEl = document.getElementById('cdUpsell');
  var upsellTrackEl = document.getElementById('cdUpsellTrack');
  var lastCart = null;

  // ── Tiered rewards ladder ──
  // "Boxes" = qty of paid packs. 2 → free shipping · 3 → +10% off · 4 → +free Variety Pack.
  // The free Variety Pack is a hidden gift variant added automatically; it never counts toward tiers.
  var GIFT_VARIANT_ID = 53375746080981; // real Variety Pack (PVB-PK-MIX-MIX-04-A); ₹480 waived via Buy-4-Get-1 discount
  var TIERS = [2, 3, 4];
  var syncingGift = false;

  // The free box is the REAL Variety Pack, flagged only by the _gift line-item property
  // (never by SKU — a paid Variety Pack must still count as a normal box).
  function isGift(it) {
    return !!(it.properties && (it.properties._gift || it.properties._free_gift));
  }

  function qualifyingBoxes(cart) {
    if (!cart.items) return 0;
    return cart.items.reduce(function (n, it) { return n + (isGift(it) ? 0 : it.quantity); }, 0);
  }

  function updateRewards(cart) {
    if (!rewardsEl) return;
    var b = qualifyingBoxes(cart);
    if (b <= 0) { rewardsEl.hidden = true; return; }
    rewardsEl.hidden = false;

    var fill = b >= 4 ? 100
      : b >= 3 ? 66.6 + (b - 3) * 33.4
      : b >= 2 ? 33.3 + (b - 2) * 33.3
      : (b / 2) * 33.3;
    if (trackFillEl) trackFillEl.style.width = Math.min(fill, 100) + '%';

    var nodes = rewardsEl.querySelectorAll('.cd-node');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.toggle('is-active', b >= TIERS[i]);
    }

    var msg;
    if (b === 1) msg = "You're <b>1 box</b> away from <b>FREE shipping</b> 🚚";
    else if (b === 2) msg = "🎉 <b>Free shipping</b> unlocked! Add <b>1 more box</b> for <b>10% off</b>";
    else if (b === 3) msg = "Nice — <b>10% off</b> applied! <b>1 more box</b> unlocks a <b>FREE Variety Pack (worth ₹480)</b> 🎁";
    else msg = "🎉 You've unlocked it all — <b>free shipping</b>, <b>10% off</b> &amp; a <b>FREE Variety Pack worth ₹480</b>!";
    if (rewardsMsgEl) rewardsMsgEl.innerHTML = msg;
  }

  function updateUpsell(cart) {
    if (!upsellEl || !upsellTrackEl) return;
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.variant_id] = true; inCart[it.id] = true; });
    var cards = upsellTrackEl.querySelectorAll('.cd-upsell-card');
    var shown = 0;
    for (var i = 0; i < cards.length; i++) {
      var vid = parseInt(cards[i].dataset.variantId, 10);
      var hide = !!inCart[vid];
      cards[i].classList.toggle('is-hidden', hide);
      if (!hide) shown++;
    }
    upsellEl.hidden = !(cart.item_count > 0 && shown > 0);
  }

  // Auto-add / auto-remove the free gift as the cart crosses the 4-box tier.
  function maybeSyncGift(cart) {
    if (!GIFT_VARIANT_ID || syncingGift) return cart;
    var boxes = qualifyingBoxes(cart);
    var gift = (cart.items || []).filter(isGift)[0];
    if (boxes >= 4 && !gift) {
      syncingGift = true;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1, properties: { _gift: 'true' } })
      }).then(function (r) { return r.json(); })
        .then(function () { syncingGift = false; return refresh(); })
        .catch(function () { syncingGift = false; });
    }
    if (boxes < 4 && gift) {
      syncingGift = true;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: gift.key, quantity: 0 })
      }).then(function (r) { return r.json(); })
        .then(function (c) { syncingGift = false; render(c); return c; })
        .catch(function () { syncingGift = false; });
    }
    return cart;
  }

  function money(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  }

  function escapeHtml(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function render(cart) {
    lastCart = cart;
    updateUpsell(cart);
    updateRewards(cart);
    // Header cart count badge (everywhere)
    var headerCount = document.querySelector('.cart-count');
    if (headerCount) headerCount.textContent = cart.item_count;
    else if (cart.item_count > 0) {
      var cartLink = document.querySelector('.cart-l');
      if (cartLink) {
        var span = document.createElement('span');
        span.className = 'cart-count';
        span.textContent = cart.item_count;
        cartLink.appendChild(span);
      }
    }

    if (countEl) countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';

    if (!cart.items || cart.items.length === 0) {
      if (emptyEl) emptyEl.style.display = '';
      if (itemsEl) itemsEl.innerHTML = '';
      if (footEl) footEl.hidden = true;
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footEl) footEl.hidden = false;
    if (subtotalEl) subtotalEl.textContent = money(cart.items_subtotal_price);

    var html = '';
    cart.items.forEach(function (item) {
      var gift = isGift(item);
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="cd-item-variant">' + escapeHtml(item.variant_title) + '</p>' : '';
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '';
      var controls = gift
        ? '<span class="cd-item-tag">🎁 Free gift · worth ₹480</span>'
        : '<button type="button" class="cd-item-remove" data-key="' + item.key + '">Remove</button>';
      var qtyBlock = gift
        ? '<span></span>'
        : '<div class="cd-qty">' +
            '<button type="button" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
          '</div>';
      var priceBlock = gift
        ? '<span class="cd-item-price"><s>' + money(item.original_line_price || item.final_line_price) + '</s>FREE</span>'
        : '<span class="cd-item-price">' + money(item.final_line_price) + '</span>';
      html +=
        '<div class="cd-item' + (gift ? ' cd-item--gift' : '') + '" data-key="' + item.key + '">' +
          '<a class="cd-item-img" href="' + item.url + '">' + img + '</a>' +
          '<div class="cd-item-main">' +
            '<a class="cd-item-name" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
            variant +
            controls +
            '<div class="cd-item-bottom">' +
              qtyBlock +
              priceBlock +
            '</div>' +
          '</div>' +
        '</div>';
    });
    if (itemsEl) itemsEl.innerHTML = html;
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return maybeSyncGift(cart); })
      .catch(function () {});
  }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return maybeSyncGift(cart); })
      .catch(function () {});
  }

  function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (window.dataLayer && data && data.price != null) {
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: 'INR',
              value: (data.price * data.quantity) / 100,
              items: [{
                item_id: data.sku || String(data.id),
                item_name: data.product_title || data.title,
                item_brand: 'Hadō',
                price: data.price / 100,
                quantity: data.quantity
              }]
            }
          });
        }
        return refresh();
      })
      .catch(function () {});
  }

  function open() {
    drawer.classList.add('open');
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('open'); });
    document.body.style.overflow = 'hidden';
    document.body.classList.add('cart-open');
  }

  function close() {
    drawer.classList.remove('open');
    drawer.setAttribute('inert', '');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('open');
    setTimeout(function () { overlay.hidden = true; }, 350);
    document.body.style.overflow = '';
    document.body.classList.remove('cart-open');
  }

  // Expose for other scripts (product-form.js opens it after an add)
  window.HadoCart = {
    open: open,
    close: close,
    refresh: refresh,
    openWithRefresh: function () { return refresh().then(open); }
  };

  // Open via header cart icon (keep /cart as no-JS fallback)
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('.cart-l');
    if (cartLink) {
      e.preventDefault();
      refresh().then(open);
      return;
    }
    if (e.target.closest('#cdClose') || e.target.closest('#cdOverlay')) {
      close();
      return;
    }
    var qtyBtn = e.target.closest('.cd-qty button');
    if (qtyBtn) {
      changeQty(qtyBtn.dataset.key, parseInt(qtyBtn.dataset.qty, 10));
      return;
    }
    var removeBtn = e.target.closest('.cd-item-remove');
    if (removeBtn) {
      changeQty(removeBtn.dataset.key, 0);
      return;
    }
    var addBtn = e.target.closest('[data-cd-add]');
    if (addBtn) {
      e.preventDefault();
      var addLabel = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      addBtn.disabled = true;
      addVariant(addBtn.dataset.cdAdd).then(function () {
        addBtn.textContent = addLabel;
        addBtn.disabled = false;
        open();
      });
      return;
    }
  });

  // GA4/Meta begin_checkout when the drawer Checkout button is used
  var checkoutForm = document.getElementById('cdCheckoutForm');
  if (checkoutForm) {
    checkoutForm.addEventListener('submit', function () {
      if (window.dataLayer && lastCart && lastCart.items) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'begin_checkout',
          ecommerce: {
            currency: 'INR',
            value: lastCart.items_subtotal_price / 100,
            items: lastCart.items.map(function (it) {
              return {
                item_id: it.sku || String(it.variant_id || it.id),
                item_name: it.product_title,
                item_brand: 'Hadō',
                price: it.final_price / 100,
                quantity: it.quantity
              };
            })
          }
        });
      }
      // do not preventDefault — let the form proceed to checkout
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) close();
  });

  // Prime the cart count on load
  refresh();
})();
